import NextImage from 'next/image'

import { PageHeroProps } from '@/organisms/PageHero/ts'
import { Media } from '@/templates/Media/Media'

function Desktop({ kind }: PageHeroProps) {
  const src = `/assets/page-hero/${kind}.png`

  return (
    <Media className="max-w-3xl lg:w-2/3 xl:max-w-2xl" greaterThanOrEqual="2md">
      <figure>
        <NextImage
          alt={kind}
          src={src}
          height="412px"
          width="687px"
          layout="responsive"
          priority
          quality={75}
        />
      </figure>
    </Media>
  )
}

export default Desktop
